<p-dialog
    [header]="(isEditing ? 'Edit Markup — ' : 'Add Markup — ') + practiceName"
    [(visible)]="visible"
    [modal]="true"
    appendTo="body"
    [style]="{ width: '28rem' }"
    (onHide)="close()">

    <div class="flex flex-column gap-4 pt-2">
        <div class="flex flex-column gap-1">
            <label class="font-medium text-sm">Markup Type</label>
            <p-dropdown
                [options]="markupTypeOptions"
                [(ngModel)]="markupType"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full" />
        </div>

        <div *ngIf="requiresCategory" class="flex flex-column gap-1">
            <label class="font-medium text-sm">Category</label>
            <p-dropdown
                [options]="categories"
                [(ngModel)]="categoryId"
                optionLabel="categoryName"
                optionValue="id"
                placeholder="Select a category"
                styleClass="w-full" />
        </div>

        <div class="flex flex-column gap-1">
            <label class="font-medium text-sm">Based On</label>
            <p-dropdown
                [options]="markupBasedOnOptions"
                [(ngModel)]="markupBasedOn"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full" />
        </div>

        <div class="flex flex-column gap-1">
            <label class="font-medium text-sm">Amount <span class="text-color-secondary">({{ amountIsPercent ? '%' : '$' }})</span></label>
            <p-inputNumber
                [(ngModel)]="amount"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                [min]="0"
                styleClass="w-full" />
        </div>

        <p-divider />

        <div *ngIf="!isEditing" class="flex align-items-center gap-2">
            <p-checkbox [(ngModel)]="replaceExisting" [binary]="true" inputId="replaceExistingMarkup" />
            <label for="replaceExistingMarkup" class="text-sm">Replace existing active markup</label>
        </div>

        <div class="flex align-items-center gap-2">
            <p-checkbox [(ngModel)]="extraDiscountSubsequentProcedures" [binary]="true" inputId="extraSubseqMarkup" />
            <label for="extraSubseqMarkup" class="text-sm">Extra discount for subsequent procedures</label>
        </div>

        <div *ngIf="extraDiscountSubsequentProcedures" class="flex flex-column gap-1">
            <label class="font-medium text-sm">Subsequent Procedure Discount <span class="text-color-secondary">(0–1)</span></label>
            <p-inputNumber
                [(ngModel)]="subsequentProcedureDiscount"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                [min]="0"
                [max]="1"
                styleClass="w-full" />
        </div>

    </div>

    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" [text]="true" (onClick)="close()" />
        <p-button
            [label]="isEditing ? 'Save Changes' : (isLocationScoped ? 'Add Markup' : 'Apply to All Locations')"
            icon="pi pi-check"
            [loading]="saving"
            [disabled]="!canSave"
            (onClick)="save()" />
    </ng-template>
</p-dialog>
